import React from  'react';
import Buttom from './Buttom'
import './list-styles.css';

const ModernWeb = () => 
  <div className="listContainer">
    <ul>
      <li>2021 - React Native / Expo / Firebase <span className="tag">WIP</span> </li>
      <li>2020 - Middleware Node/Express
        <Buttom title="Heroku App" src="https://meetime-rdstation.herokuapp.com/" />
        <Buttom title="Github" src="https://github.com/marceloleitemt/" />
      </li>
      <li>2016-2020 - Credilink Agile Team <Buttom title="LinkedIN" src="https://www.linkedin.com/in/marceloleitemt/"/></li>
    </ul>
  </div>

export default ModernWeb